"use strict";

module.exports = ['$resource', function ( $resource ) {

	let Role = $resource('/roles/:id',
		{
			id: '@id'
		},
		{
			'save': {method:'POST'},
			'update': {method: 'PATCH'}
		}
	);

	var save = Role.save;

	// Required for "easy" .save in controllers
	Role.save = function ( ...args ) {

		if( args[0].id ) {
			this.update.apply(this, args);
		} else {
			save.apply(this, args);
		}
	};

	return Role;
}];
